import { Box, Container, Text, VStack } from "@chakra-ui/react";
import { personMetadata, siteMetadata } from "../seo/pageMetadata";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box as="footer" bg="cle.cream" borderTop="1px solid" borderColor="cle.beige" py={{ base: 8, md: 10 }}>
      <Container maxW="6xl" px={{ base: 6, md: 8 }}>
        <VStack spacing={4} textAlign="center">
          <Text fontSize="xs" color="cle.muted">
            Operated by {personMetadata.name} · {siteMetadata.organization.foundingLocation}
          </Text>

          <Text fontSize="xs" color="cle.muted">
            © {currentYear} {siteMetadata.organization.name}. All rights reserved.
          </Text>
        </VStack>
      </Container>
    </Box>
  );
};

export default Footer;
